export default "__VITE_ASSET__8861edd3__"